const fetchMonthToDateRed = ( state = {
    status: 'init',
    isFetching: false,
    showLoading: true,
}, action ) => {
    if ( action.type === 'FETCH_MONTH_TO_DATE' ) {
        console.log( ' FETCH_MONTH_TO_DATE Reducer ', action.payload.status )
        switch ( action.payload.status ) {
            case 'init':
                console.log( ' FETCH_MONTH_TO_DATE changed init to fetching...', state)
                return Object.assign( {}, state, {
                    status: 'fetching',
                })
            case 'fetching':
                console.log( ' FETCH_MONTH_TO_DATE ==> Fetching now...', state)
                return state;
            case 'succeed':
                console.log( ' FETCH_MONTH_TO_DATE ==> SUCCEED! ', state)
                return Object.assign( {}, state, {
                    status: 'succeed',
                    data: action.payload.data
                })
            case 'failed':
                console.log( ' the month to date request failed, handling these need to be implemented!');
                return state;
            default:
                return state
        }
    }
    return state;
}

export default fetchMonthToDateRed;


/** WEBPACK FOOTER **
 ** ./src/reducers/fetchMonthToDateRed.js
 **/